import { Reveal, Chapter } from "@/components/Reveal";

const SECTORS = [
  {
    title: "Culinary Leadership",
    img: "https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?q=80&w=1400&auto=format&fit=crop",
    roles: [
      "Executive Chefs",
      "Executive Sous Chefs",
      "Chef de Cuisine",
      "Sous Chefs",
      "Pastry Chefs",
      "Specialist Culinary Talent",
    ],
    copy: "We identify culinary leaders capable of translating a concept into a distinctive dining identity.",
    focus: [
      "Culinary Innovation",
      "Menu Development",
      "Kitchen Leadership",
      "Food Cost Control",
      "Team Development",
      "Operational Consistency",
    ],
  },
  {
    title: "Restaurant & F&B Leadership",
    img: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=1400&auto=format&fit=crop",
    roles: [
      "General Managers",
      "Restaurant Managers",
      "Food & Beverage Directors",
      "Assistant Directors of F&B",
      "Beverage Managers",
      "Head Sommeliers",
      "Front-of-House Leaders",
    ],
    copy: "We recruit hospitality leaders who understand both operational excellence and the art of creating memorable guest experiences.",
    focus: [
      "Luxury Service",
      "Revenue Performance",
      "Team Leadership",
      "Labor Optimization",
      "Beverage Strategy",
      "Guest Experience",
    ],
  },
  {
    title: "Luxury Hotel Staffing",
    img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=1400&auto=format&fit=crop",
    roles: [
      "Hotel General Managers",
      "Directors of Operations",
      "Directors of Food & Beverage",
      "Front Office Leadership",
      "Guest Relations",
      "Concierge Leadership",
      "Rooms Division",
      "Sales & Marketing",
      "Culinary Leadership",
    ],
    copy: "We recruit high-calibre hospitality professionals for luxury hotels, boutique properties and international resorts.",
    focus: [
      "Rooms Division",
      "Front Office Excellence",
      "Guest Experience",
      "Brand Standards",
      "Sales & Revenue",
      "Operational Leadership",
    ],
  },
];

const Sectors = () => (
  <section id="recruitment" data-testid="sectors-section" className="bg-ivory py-28 lg:py-40">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="03" label="Strategic Sectors" />
      </Reveal>
      <div className="grid lg:grid-cols-2 gap-10 items-end mb-16 lg:mb-24">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] text-ink">
            Specialist Hospitality <span className="italic text-bronze">Recruitment</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-sm text-ink/60 leading-relaxed max-w-md lg:justify-self-end">
            Targeted search methodologies designed specifically for premium restaurants, luxury
            hotels, resorts and hospitality groups.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-10 lg:gap-8">
        {SECTORS.map((s, i) => (
          <Reveal key={s.title} delay={0.1 + i * 0.12}>
            <article
              data-testid={`sector-card-${i}`}
              className="group border border-ink/10 bg-ivory h-full flex flex-col"
            >
              <div className="overflow-hidden aspect-[4/3]">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out"
                />
              </div>
              <div className="p-8 lg:p-10 flex flex-col flex-1">
                <h3 className="font-serif text-2xl lg:text-3xl font-light text-ink">{s.title}</h3>
                <p className="mt-4 text-sm text-ink/60 leading-relaxed">{s.copy}</p>
                <ul className="mt-6 space-y-2">
                  {s.roles.map((r) => (
                    <li key={r} className="flex items-center gap-3 text-sm text-ink/75">
                      <span className="w-1 h-1 bg-bronze rounded-full shrink-0" />
                      {r}
                    </li>
                  ))}
                </ul>
                {s.focus.length > 0 && (
                  <div className="mt-7 pt-6 border-t border-ink/10 flex flex-wrap gap-2">
                    {s.focus.map((f) => (
                      <span
                        key={f}
                        className="text-[9px] tracking-[0.18em] uppercase text-ink/50 border border-ink/15 px-3 py-1.5"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Sectors;
